import React, { Component } from "react";
import { Popup, PopupContainer, PopupContent, PopupPreview } from "../../Components/Popup";
import { AiIcon, SlideAiButton } from "./SlideAiIcon";
import { _ } from "js/vendor";
import styled from "styled-components";
import { CanvasEventType } from "../../../common/constants";
import { CategoryController } from "../../../common/SlideCategories/CategoryController";
import { computeChangeSet, mergeChanges } from "../../../common/utils/changeset";
import { findElementsWithImages } from "../../../common/utils/findElementsWithImages";
import { ToolTipBadge } from "../../Components/ToolTip";
import AiGenerationService from "../../core/services/aiGeneration";
import CanvasPreview from "../../react/components/CanvasPreview";
import { themeColors } from "../../react/sharedStyles";
import PresentationEditorController from "../PresentationEditor/PresentationEditorController";
import { Button } from "../../Components/Button";
import { Gap10, Gap20 } from "../../react/components/Gap";
import { SimpleLabel } from "../../react/components/SimpleLabel";
import { SlideAiDialog } from "./SlideAiDialog";
import { ShowDialog, ShowWarningDialog } from "../../react/components/Dialogs/BaseDialog";
import { AiSlideContentEditor } from "../AiGeneration/GeneratePresentation/Components/AiSlideContentEditor";
import { WithLabel } from "../../Components/WithLabel";
import { marked } from "marked";
import { TextField } from "../../Components/TextField";
import { FlexBox } from "../../react/components/LayoutGrid";
import { PropertyPanelContainer, PropertySection, PropertySectionHeader } from "../../EditorComponents/PropertyPanel";
import { ToggleSwitch } from "../../Components/ToggleSwitch";
import GeneratePresentationController from "../AiGeneration/GeneratePresentation/GeneratePresentationController";
import { Dropdown } from "../../Components/Dropdown";
import { MenuItem } from "../../Components/Menu";
import Spinner from "../../react/components/Spinner";
import { Popover } from "@material-ui/core";

const SLIDE_WIDTH = 400;
const SLIDE_HEIGHT = SLIDE_WIDTH * (9 / 16);

const Container = styled.div`
    //padding: 0px 20px 20px;
    width: 95vw;
    height: 95vh;
    max-width: 1350px;
    //max-height: 700px;
`;

const Banner = styled.div`
    background: ${themeColors.aiColor};
    color: white;
    font-weight: bold;
    font-size: 18px;
    padding: 10px 20px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 10px;
`;

const Controls = styled.div`

`;

const ScrollBox = styled.div`
    display: flex;
    flex-direction: row;
    gap: 20px;
    align-items: center;
    width: 100%;
    overflow-y: scroll;
    flex-wrap: wrap;
`;

const SlideCategory = styled.div`
    display: flex;
    gap: 10px;
    flex-direction: column;
`;

const SlidePreviews = styled.div`
    display: flex;
    flex-direction: row;
    gap: 20px;
    padding-bottom: 10px;
    flex-wrap: wrap;
`;

const CategoryLabel = styled.div`
    display: flex;
    font-weight: bold;
    padding: 10px 0px 0px;
    align-items: center;
    justify-content: flex-start;
`;

const CanvasPreviewWrapper = styled.div`
    position: relative;
    width: ${SLIDE_WIDTH}px;
    height: ${SLIDE_HEIGHT}px;
    cursor: pointer;
    border: solid 1px #ccc;
    overflow: hidden;
        // outline: ${props => props.selected ? `3px solid ${themeColors.ui_blue}` : "none"};
        //outline: ${props => `10px solid ${props.categoryColor}`};
`;

const TextContainer = styled.div`
    background: #fff;
    border: solid 1px #ccc;
    padding: 10px;
    width: 100%;
    min-height: 100px;
    pointer-events: auto;
`;

export class SlideAiPanel extends Component {
    constructor(props) {
        super(props);

        let metadata = props.currentSlide.getMetadata() ?? {
            title: "Loading..."
        };

        let prompt = metadata.slidePrompt ?? metadata.slideContent ?? "";

        if (typeof prompt === "object") {
            prompt = JSON.stringify(prompt, null, 2);
        }
        prompt = marked.parse(prompt);

        this.state = {
            currentModel: _.cloneDeep(props.currentSlide.attributes),
            isGenerating: false,
            selectedModel: null,
            textDensity: 1,
            slideCategory: null,
            slideCategories: [],
            originalSlidePrompt: metadata.originalSlidePrompt,
            slidePrompt: prompt,
            slideType: "auto",
            preserveExactText: !!metadata.preserveExactText,
            files: metadata.files ? metadata.files.map(f => f.hasBeenUsedFor === "slide" ? ({ ...f, hasBeenUsed: false }) : f) : [],
            isDragging: false,
            isSavingFiles: false
        };

        this.hasBeenUnmounted = false;
    }

    componentDidMount() {
        const { currentSlide } = this.props;
        // if (currentSlide.getMetadata()?.hasBeenViewed === false) {
        currentSlide.updateMetadata({ hasBeenViewed: true });
        this.setState({ slideGen: currentSlide.getMetadata() });
        this.renderSlideModels(currentSlide.getMetadata()?.generatedSlides ?? [], true);
        // }
    }

    componentDidUpdate(prevProps, prevState) {
        const { canvasController, currentSlide } = this.props;
        const { textDensity } = this.state;

        if (prevProps.currentSlide !== currentSlide) {
            this.setState({
                currentModel: _.cloneDeep(currentSlide.attributes),
                isGenerating: false,
                selectedModelIndex: null,
                slideCategory: null
            });
        }
    }

    componentWillUnmount() {
        this.hasBeenUnmounted = true;
    }

    shouldComponentUpdate(nextProps) {
        return !nextProps.canvasController?.canvas?.isAnimating;
    }

    setStateAsync = async stateUpdate => {
        await new Promise(resolve => this.setState(stateUpdate, resolve));
    }

    handleRegenerateSlide = () => {
        const { currentSlide, currentCanvasController } = this.props;
        ShowDialog(SlideAiDialog, { slide: currentSlide, canvas: currentCanvasController.canvas, onClose: this.regenerateSlide });
    }
    //
    // handleRegenerateImage = async () => {
    //     const { currentSlide, currentTheme } = this.props;
    //
    //     const metadata = currentSlide.getMetadata();
    //     const slideImage = metadata.generatedModel?.slideImage;
    //     const imageSource = metadata.imageSource ?? "ai";
    //
    //     let { imagePrompt, imageStyle } = await ShowDialogAsync(RegenerateImageDialog, {
    //         currentSlide,
    //         theme: currentTheme,
    //         prompt: slideImage?.prompt || "",
    //         imageSource: imageSource,
    //         imageStyle: slideImage?.imageStyle || "minimalist",
    //     });
    //
    //     if (!imagePrompt) {
    //         return;
    //     }
    //
    //     imageStyle = imageStyle || slideImage?.imageStyle || "";
    //
    //     await currentSlide.resetSlideImage();
    //
    //     const generatedSlides = currentSlide.getMetadata()?.generatedSlides;
    //     this.renderSlideModels(generatedSlides, true);
    //
    //     const { slide } = await AiGenerationService.regenerateSlideImage({
    //         slide: currentSlide.attributes,
    //         imagePrompt,
    //         imageStyle
    //     });
    //
    //     currentSlide.update(slide);
    //     await currentSlide.updatePromise;
    //
    //     this.renderSlideModels(generatedSlides, true);
    // }
    //
    regenerateSlide = async () => {
        const slideGen = {
            slidePrompt: this.state.slidePrompt,
            slideType: this.state.slideType,
            preserveExactText: this.state.preserveExactText,
            files: this.state.files,
        };

        const { currentSlide } = this.props;

        this.setState({
            currentModel: _.cloneDeep(currentSlide.attributes),
            isGenerating: true,
            selectedModelIndex: 0,
        });

        currentSlide.update({ metadata: { ...currentSlide.getMetadata(), ...slideGen } });
        console.log("Regenerating slide with state:", slideGen);

        let response = await AiGenerationService.generateSlideData({
            slideId: currentSlide.id,
            presentationId: currentSlide.presentation.id,
            slidePrompt: slideGen.slidePrompt,
            slideType: slideGen.slideType,
            slideIndex: currentSlide.getIndex(),
            preserveExactText: slideGen.preserveExactText || false,
            files: slideGen.files || [],
            presentationTopic: currentSlide.presentation.get("metadata").topic
        });

        console.log(response);

        if (!response.slides || response.slides.length == 0) {
            ShowWarningDialog({ title: "Slide AI", message: "Sorry, we couldn't generate a new slide for you. Please try again." });
            this.setState({ isGenerating: false });
            return;
        }

        this.renderSlideModels(response.slides, slideGen.slidePrompt);
    }

    renderSlideModels = async (generatedSlides, slidePrompt) => {
        const { currentSlide } = this.props;

        let slideCategories = [];
        for (let slide of generatedSlides) {
            let slideModel = slide.slideData;
            slideModel.slideImage = currentSlide.getMetadata().generatedModel?.slideImage;
            slideModel.imageStylePrompt = currentSlide.getMetadata().imageStylePrompt;

            console.log("Category", slideModel.slideCategory);
            console.log("Reasoning:", slideModel.slideReasoning);
            console.log(slideModel);

            let category = CategoryController.getCategory(slideModel.slideCategory);
            let models = category.getSlideModels(slideModel);

            // copy over metadata from the generated slide data
            models = models.map(model => ({
                ...model,
                metadata: {
                    ...currentSlide.getMetadata(),
                    ...model.metadata,
                    generatedSlides,
                    aiGenerated: true,
                    originalSlidePrompt: slidePrompt,
                    slidePrompt: slideModel.slidePrompt,
                    slideCategory: slideModel.slideCategory,
                    slideReasoning: slideModel.slideReasoning,
                    slideConfidence: slideModel.slideConfidence
                }
            }));

            models.forEach(model => {
                let elementsWithImages = findElementsWithImages(model);
                for (let element of elementsWithImages) {
                    if (!element.content_value && element.__generateImage) {
                        element.__generateImage.isGenerating = true;
                    }
                }
            });

            slideCategories.push({
                slideCategory: slideModel.slideCategory,
                slideReasoning: slideModel.slideReasoning,
                slideConfidence: slideModel.slideConfidence,
                models
            });
        }

        await this.setStateAsync({
            slideCategories,
            isGenerating: false
        });

        for (let cat of slideCategories) {
            let models = cat.models;
            for (let idx = 0; idx < models.length; idx++) {
                let { slide } = await AiGenerationService.generateImagesForSlide({
                    slide: models[idx]
                });

                if (this.state.slideCategories !== slideCategories || this.hasBeenUnmounted) {
                    // If the preview models have changed or the component has been unmounted, stop generation
                    break;
                }

                let { update, hasUpdates } = computeChangeSet(models[idx], slide);
                if (hasUpdates) {
                    let updatedModel = mergeChanges(models[idx], update);
                    this.setState(state => {
                        // Keep the array reference, only replace a single model
                        const slideCategories = state.slideCategories;
                        slideCategories[slideCategories.indexOf(cat)].models[idx] = updatedModel;
                        return {
                            ...state,
                            slideCategories
                        };
                    });
                }
            }
        }
    }

    handleApplySlide = model => {
        const { currentSlide, currentCanvasController, closePopup } = this.props;
        const { slideGen } = this.state;

        closePopup();

        currentCanvasController.canvas.once(CanvasEventType.REFRESH, () => {
            window.requestAnimationFrame(() => {
                PresentationEditorController.playAnimation();
            });
        });

        currentSlide.update({
            ...currentSlide.attributes,
            animations: {},
            states: model.states,
            layout: model.layout,
            template_id: model.template_id,
            version: 10,
            migrationVersion: 10.03,
            metadata: {
                ...slideGen,
                ...model.metadata,
                needsLayoutProcessing: true
            }
        }, { removeMissingKeys: true });

        this.setState({ selectedModel: model });
    }

    render() {
        const { currentSlide } = this.props;
        const { isGenerating, selectedModel, slideCategories, slidePrompt, preserveExactText, language } = this.state;

        return (
            <Container>
                <Banner><AiIcon /> Slide AI</Banner>
                <PropertyPanelContainer fullHeight>
                    <PropertySection>
                        <WithLabel label="Slide Prompt" above left>
                            {/*<TextField variant="outlined" multiline fullWidth*/}
                            {/*           value={slidePrompt} onChange={slidePrompt => this.setState({ slidePrompt })}*/}
                            {/*           style={{ background: "white", userSelect: "text" }}*/}
                            {/*/>*/}

                            <TextContainer>
                                <AiSlideContentEditor text={slidePrompt} onChange={slidePrompt => this.setState({ slidePrompt })} />
                            </TextContainer>
                        </WithLabel>
                        <FlexBox left middle fillWidth gap={20}>
                            <Button onClick={this.regenerateSlide}>Regenerate Slide Ideas</Button>
                            <Popup label="Regenerate Options" showArrow>
                                <PopupContent>
                                    {closePopup => (
                                        <PopupContainer>
                                            <PropertyPanelContainer>
                                                <PropertySection>
                                                    <WithLabel label="Preserve Exact Text" toolTip="Try to keep the text in the generated presentation slides exactly as it appears in the outline.">
                                                        <ToggleSwitch value={preserveExactText} onChange={value => GeneratePresentationController.setPreserveExactText(value)} />
                                                    </WithLabel>
                                                </PropertySection>
                                                <PropertySection>
                                                    <WithLabel label="Language">
                                                        <Dropdown value={language} onChange={value => GeneratePresentationController.setLanguage(value)}>
                                                            <MenuItem value="eng">English</MenuItem>
                                                            <MenuItem value="es">Spanish</MenuItem>
                                                            <MenuItem value="fr">French</MenuItem>
                                                            <MenuItem value="de">German</MenuItem>
                                                        </Dropdown>
                                                    </WithLabel>
                                                </PropertySection>
                                            </PropertyPanelContainer>
                                        </PopupContainer>
                                    )}
                                </PopupContent>
                            </Popup>
                        </FlexBox>
                    </PropertySection>
                    <PropertySection expanded>
                        <WithLabel label="Generated Ideas" above left fillHeight fillWidth>
                            {isGenerating && <Spinner label="Generating slides..." />}
                            {!isGenerating &&
                                <ScrollBox>
                                    <SlidePreviews>
                                        {slideCategories.map(category => (
                                            category.models.map((model, index) => (
                                                <CanvasPreviewWrapper key={index}
                                                    categoryColor={category.categoryColor}
                                                    selected={selectedModel == model}
                                                    onClick={() => this.handleApplySlide(model)}
                                                >
                                                    <CanvasPreview slideModel={model} width={SLIDE_WIDTH} />
                                                </CanvasPreviewWrapper>
                                            )
                                            )))}
                                    </SlidePreviews>
                                    {/*{slideCategories.map(category => (*/}
                                    {/*    <SlideCategory>*/}
                                    {/*        <CategoryLabel>{category.slideCategory.replace("_", " ").toTitleCase()} slides&nbsp;&nbsp;*/}
                                    {/*            <ToolTipBadge><strong>Why did we suggest {category.slideCategory.replace("_", " ").toTitleCase()} slides? ({category.slideConfidence}% match)</strong><br /><br />{category.slideReasoning}</ToolTipBadge>*/}
                                    {/*        </CategoryLabel>*/}
                                    {/*        <SlidePreviews>*/}
                                    {/*            {category.models.map((model, index) => (*/}
                                    {/*                <CanvasPreviewWrapper key={index}*/}
                                    {/*                                      categoryColor={category.categoryColor}*/}
                                    {/*                                      selected={selectedModel == model}*/}
                                    {/*                                      onClick={() => this.handleApplySlide(model)}*/}

                                    {/*                >*/}
                                    {/*                    <CanvasPreview slideModel={model} width={SLIDE_WIDTH} />*/}
                                    {/*                </CanvasPreviewWrapper>*/}
                                    {/*            ))}*/}
                                    {/*        </SlidePreviews>*/}
                                    {/*    </SlideCategory>*/}
                                    {/*))}*/}
                                </ScrollBox>
                            }
                        </WithLabel>
                    </PropertySection>
                </PropertyPanelContainer>
            </Container>
        );
    }
}

export class SlideAIPopupButton extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isOpen: false,
        };
    }

    render() {
        const { isOpen } = this.state;

        let anchorPosition = {
            top: 20,
            left: (window.innerWidth - 1350) / 2,
        };

        return (
            <>
                <SlideAiButton onClick={() => this.setState({ isOpen: true })} />

                <Popover
                    open={isOpen}
                    disableEnforceFocus
                    anchorReference="anchorPosition"
                    anchorPosition={anchorPosition}
                    onClose={() => this.setState({ isOpen: false })}
                    PaperProps={{
                        style: { overflow: "hidden" }
                    }}
                    BackdropProps={{
                        invisible: false
                    }}
                >
                    <SlideAiPanel {...this.props} closePopup={() => this.setState({ isOpen: false })} />
                </Popover>
            </>
        );
    }
}
